import { useMsal } from '@azure/msal-react';
import { useGoogleAuth } from '../contexts/GoogleAuthContext';

/**
 * Returns true if the current MSAL user is a member of the configured Owner group
 * (REACT_APP_OWNER_GROUP_ID). This group is independent from the Admin group and
 * gates the most sensitive actions, such as creating registrations.
 *
 * The `groups` claim must be enabled on the Entra app registration:
 *   App Registration > Token configuration > Add groups claim > Security groups.
 */
export function useIsOwner(): boolean {
    const { accounts } = useMsal();
    const { isGoogleAuthenticated } = useGoogleAuth();

    if (isGoogleAuthenticated) {
        return false;
    }

    const ownerGroupId = process.env.REACT_APP_OWNER_GROUP_ID;
    if (!ownerGroupId) {
        // No owner group configured: deny by default (fail-closed).
        return false;
    }

    const claims = accounts[0]?.idTokenClaims as Record<string, unknown> | undefined;
    const groups = claims?.['groups'];
    if (!Array.isArray(groups)) {
        return false;
    }

    return (groups as string[]).some(
        (g) => g.toLowerCase() === ownerGroupId.toLowerCase()
    );
}
